<template>
	<div class="content">
		<section class="head-section">
			<div class="container cols-2">
				<div class="images-col">
					
					<picture class="full-image">
						<source srcset="../assets/images/photozone-1.webp" type="image/webp">
						<img src="../assets/images/photozone-1.jpg" alt="Photozone Flowers" :ref="setImagemRef">
					</picture>
					<picture class="hover-image">
						<source srcset="../assets/images/photozone-2.webp" type="image/webp">
						<img src="../assets/images/photozone-2.jpg" alt="Photozone Flowers" :ref="setImagemRef"/>
					</picture>
					<picture class="hover-image-2">
						<source srcset="../assets/images/photozone-3.webp" type="image/webp">
						<img src="../assets/images/photozone-3.jpg" alt="Photozone Flowers" :ref="setImagemRef"/>
					</picture>
				</div>
				<div class="content">
					<h1 class="title">Фотозона у садовому центрі</h1>
					<p>Ми відкриті для всіх! Приїжджайте за рослинами для себе або просто так. Організовуйте фотозйомки у нашому садовому центрі серед квітів. Приїжджайте з дітьми на екскурсію територією Lemberg Flowers.</p>
				</div>
			</div>
		</section>
		<section class="section-gallery">
			<div class="container">
				<div class="gallery">
					<div v-for="(img, index) in gallery"
					:key="index" :class="'pic ' + img.size"
					@click="() => showGalleryImg(index)">
					<picture>
						<source :srcset="typeof img === 'string' ? img : img.webp" type="image/webp">
						<img :src="typeof img === 'string' ? img : img.thumbnail" alt="Photozone Flowers" :ref="setImagemRef"/>
					</picture>
						
					</div>
				</div>
				<vue-easy-lightbox
					:visible="visibleImg"
					:imgs="gallery"
					:index="indexGallery"
					:moveDisabled = "moveDisabled"
					:scrollDisabled = "scrollDisabled"
					:swipeTolerance = "swipeTolerance"
					:escDisabled="escDisabled"
					:loop="loop"
					@hide="handleGalleryHide">
						
					</vue-easy-lightbox>
			</div>
		</section>
		<section>
			<div class="container">
				<v-form/>
			</div>
		</section>
		<section>
			<v-contacts/>
		</section>
	</div>
</template>
<style scoped lang="scss">
	@import "../assets/scss/components/photozone-page.scss";
</style>

<script>
	import VueEasyLightbox from 'vue-easy-lightbox' 
	import ContactForm from '@/components/ContactForm.vue'
	import Contacts from '@/components/Contacts.vue'

	import { ref, onMounted, onBeforeUpdate } from 'vue'


	export default {
		setup() {
			let imageRefs = ref([])
			const setImagemRef = el => {
				if (el) {
					imageRefs.value.push(el)
				}
			}
		onMounted(() => {
			imageRefs.value.forEach(function(entry) {
				entry.width = entry.clientWidth
				entry.height = entry.clientHeight
			});
		})
		onBeforeUpdate(() => {
			imageRefs.value = []

		})
			return {
				setImagemRef
			}
		},
		components: {
			VueEasyLightbox,
			'v-contacts': Contacts,
			'v-form': ContactForm
		},
		data(){
			return {
				list:[
					{
						title:'З 1-го лютого до 15 квітня',
						descr: 'Чекаємо Ваші кашпо, горщики, ящики у нашому садовому центрі'
					},
					{
						title:'Вибір рослин',
						descr: 'В нас широкий асортимент для озеленення балконів та терас'
					},
					{
						title:'Оформлення замовлення',
						descr: ''
					},
					{
						title:'Вирощування в парнику',
						descr: 'В нас створені всі умови для швидкого та правильно вирощування ваших рослин'
					},
					{
						title:'До 10 травня (по готовності)',
						descr: 'Забираєте Ваші готові замовлення'
					}
				],
				visibleImg: false,
				indexGallery: 0,
				moveDisabled:true,
				scrollDisabled : true,
				swipeTolerance : 50,
				escDisabled : true,
				loop: true,
				gallery: [
				{
					src: require('../assets/images/photozone-gallery/image-1.jpg'),
					thumbnail: require('../assets/images/photozone-gallery/small-1.jpg'),
					webp: require('../assets/images/photozone-gallery/small-1.webp'),
					size: '' 
				},
				{
					src: require('../assets/images/photozone-gallery/image-2.jpg'),
					thumbnail: require('../assets/images/photozone-gallery/small-2.jpg'),
					webp: require('../assets/images/photozone-gallery/small-2.webp'),
					size: 'auto'
				},
				{
					src: require('../assets/images/photozone-gallery/image-3.jpg'),
					thumbnail: require('../assets/images/photozone-gallery/small-3.jpg'),
					webp: require('../assets/images/photozone-gallery/small-3.webp'),
					size: '' 
				},
				{
					src: require('../assets/images/photozone-gallery/image-4.jpg'),
					thumbnail: require('../assets/images/photozone-gallery/small-4.jpg'),
					webp: require('../assets/images/photozone-gallery/small-4.webp'),
					size: 'auto' 
				},
				{
					src: require('../assets/images/photozone-gallery/image-5.jpg'),
					thumbnail: require('../assets/images/photozone-gallery/small-5.jpg'),
					webp: require('../assets/images/photozone-gallery/small-5.webp'),
					size: '' 
				},
				{
					src: require('../assets/images/photozone-gallery/image-6.jpg'),
					thumbnail: require('../assets/images/photozone-gallery/small-6.jpg'),
					webp: require('../assets/images/photozone-gallery/small-6.webp'),
					size: 'auto'
				}

			]
			} 
		},
		methods: {
			showGalleryImg(index) {
				this.indexGallery = index
				this.visibleImg = true
			},
			handleGalleryHide() {
				this.visibleImg = false
			}
		}
	}
</script>
